import { RegionCard } from '@sunwebgroup/uds-ui/region-card'
import { useCMSPageField } from '@/cms/fields'
import { useIntl } from '@/intl'
import { MediaServerLazyImage } from '@/scopes/common/components/MediaServerLazyImage'
import SectionTitle from '@/scopes/destinations/components/SectionTitle'
import { useDestinationTitleValues } from '@/scopes/destinations/components/useDestinationTitleValues'
import { useRegionsTitleKey } from '@/scopes/destinations/components/useRegionsTitleKey'
import styles from './Regions.module.css'

export default function Regions() {
  const intl = useIntl()

  const title = useRegionsTitleKey('regions')
  const destinationTitleValues = useDestinationTitleValues({ shouldUseSpecialPreposition: false })

  const regions = useCMSPageField('DestinationPage.regions')

  if (regions.length === 0) {
    return null
  }

  return (
    <section>
      <SectionTitle>{intl.formatMessage({ id: title }, destinationTitleValues)}</SectionTitle>
      <div className={styles.regionsGrid}>
        {regions.map(region => (
          <a href={region.link} key={region.name} className={styles.regionLink}>
            <RegionCard
              text={region.name}
              src={region.image}
              aspectRatio="16:9"
              alt={intl.formatMessage({ id: 'destination_region_img_alt' }, { regionName: region.name })}
              imageSlot={props => (
                <MediaServerLazyImage
                  {...props}
                  widths={[320, 480, 600]}
                />
              )}
            />
          </a>
        ))}
      </div>
    </section>
  )
}
